/* You Fly LA — direct-to-calendar booking CTAs + enrollment pop-up.
   Booking: every link to a bookable product (and every generic "Book A Discovery Flight" / "#discovery" CTA)
   becomes a Cowlendar direct link, so the calendar opens instead of the product page.
   The weight/terms consent gate (yfla-consent-gate) still runs first for flights.
   Enrollment: any link to #enroll, any [data-enroll], and the package "Enroll Now" buttons open the intake pop-up.

   v22 (2026-09-15): site-wide sweep widened —
     • links to the /pages/book-a-consultation page now open the consultation calendar (232 page-body CTAs
       pointed at the page rather than the product);
     • "Book …" links to the discovery collections / pillar pages open the discovery-flight calendar;
     • links whose href is set AFTER insertion (search-drawer resource cards) are caught by an attribute observer;
     • a link may opt out with data-yfla-nocal="1" (used for "see all flights" style links that must stay links). */
(function(){
'use strict';
var COW=window.YFLA_COW||{};
var DEFAULT_FLIGHT='discovery-flight-los-angeles';
var CONSULT='book-a-consultation';
var CAL='https://app.cowlendar.com/cal/';
var BOOK_TEXT=/^\s*(book|reserve|schedule)\b/i;
/* Pages and collections that a "Book …" CTA may point at; all of them mean "book a discovery flight". */
var FLIGHT_TARGETS=/^(?:https?:\/\/[^\/]+)?\/(?:collections\/discovery-flights(?:-for-two)?|pages\/(?:discovery-flights-los-angeles|discovery-flight-cost|what-to-expect|what-is-a-discovery-flight|airplane-rides-los-angeles|introductory-flight-los-angeles|discovery-flight-near-me))\/?(?:[?#].*)?$/i;
var CONSULT_TARGETS=/^(?:https?:\/\/[^\/]+)?\/pages\/book-a-consultation\/?(?:[?#].*)?$/i;

function bookable(href,a){
  if(!href)return null;
  var m=href.match(/^(?:https?:\/\/[^\/]+)?\/products\/([a-z0-9-]+)/i);
  if(m)return COW[m[1]]?m[1]:null;
  if(/(^|\/)#discovery$/.test(href))return DEFAULT_FLIGHT;
  if(CONSULT_TARGETS.test(href))return COW[CONSULT]?CONSULT:null;
  if(FLIGHT_TARGETS.test(href)&&a&&BOOK_TEXT.test(a.textContent||''))return COW[DEFAULT_FLIGHT]?DEFAULT_FLIGHT:null;
  return null;
}
function rewrite(a){
  if(a.getAttribute('data-yfla-cal')||a.getAttribute('data-yfla-nocal'))return;
  var h=bookable(a.getAttribute('href'),a);
  if(!h)return;
  var c=COW[h];
  a.setAttribute('href',CAL+c[0]+'/'+c[1]);
  a.setAttribute('data-cowlendar-btn',c[0]+'-'+c[1]);
  a.setAttribute('data-yfla-handle',h);
  a.setAttribute('data-yfla-cal','1');
  a.removeAttribute('target');
}
function sweep(root){(root||document).querySelectorAll('a[href]').forEach(rewrite)}
sweep();
new MutationObserver(function(ms){ms.forEach(function(m){
  if(m.type==='attributes'){if(m.target.nodeType===1&&m.target.matches('a[href]'))rewrite(m.target);return}
  m.addedNodes.forEach(function(n){if(n.nodeType===1){if(n.matches&&n.matches('a[href]'))rewrite(n);sweep(n)}})
})}).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
/* Late sweep for anything rendered by apps after load (search drawer, recommendations). */
window.addEventListener('load',function(){setTimeout(function(){sweep()},1500)});
window.YFLA_bookSweep=sweep;

/* ---- enrollment pop-up ---- */
var em=document.getElementById('yfla-em');
if(!em)return;
var form=document.getElementById('yfla-em-form'),prog=document.getElementById('yfla-em-prog'),pkg=document.getElementById('yfla-em-pkg'),pageF=document.getElementById('yfla-em-page'),err=document.getElementById('yfla-em-err'),go=document.getElementById('yfla-em-go');
var PROG={ppl:'Private Pilot License (PPL)',sport:'Sport Pilot',ir:'Instrument Rating',cpl:'Commercial Pilot',me:'Multi-Engine Rating',cfi:'Flight Instructor (CFI / CFII / MEI)',atp:'Airline Pilot Program (Zero-To-Airline)',teen:'Teen Flight Training',disc:'Discovery Flight'};
function openEM(opts){
  opts=opts||{};
  em.classList.remove('done');
  err.style.display='none';
  var cp=document.querySelector('.yfla-course[data-program]');
  var id=opts.program||(cp?cp.getAttribute('data-program'):'');
  if(id&&PROG[id])prog.value=PROG[id];
  pkg.value=opts.pkg||'';
  pageF.value=location.pathname;
  em.classList.add('on');
  document.documentElement.style.overflow='hidden';
  setTimeout(function(){try{form.querySelector('input[type=text]').focus()}catch(e){}},80);
}
function closeEM(){em.classList.remove('on');document.documentElement.style.overflow=''}
window.YFLA_openEnroll=openEM;
document.getElementById('yfla-em-x').addEventListener('click',closeEM);
document.getElementById('yfla-em-done').addEventListener('click',function(e){e.preventDefault();closeEM()});
em.addEventListener('click',function(e){if(e.target===em)closeEM()});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&em.classList.contains('on'))closeEM()});
em.querySelectorAll('.card input').forEach(function(r){r.addEventListener('change',function(){em.querySelectorAll('.card input[name="'+r.name+'"]').forEach(function(x){x.closest('.card').classList.toggle('on',x.checked)})})});

document.addEventListener('click',function(e){
  var a=e.target.closest?e.target.closest('a[href],[data-enroll]'):null;
  if(!a)return;
  var href=a.getAttribute('href')||'';
  if(a.hasAttribute('data-enroll')||/(^|\/)#enroll$/.test(href)||a.hasAttribute('data-pick')){
    e.preventDefault();
    openEM({program:a.getAttribute('data-pick')||a.getAttribute('data-enroll')||'',pkg:a.getAttribute('data-pkg')||''});
  }
},true);

form.addEventListener('submit',function(){
  /* Native submit on purpose: Shopify's spam protection injects its CAPTCHA token into
     {% form 'contact' %} forms on a real submit. The page reloads with ?contact_posted=true
     and the block below reopens the pop-up in its success state. */
  try{sessionStorage.setItem('yfla_em','1')}catch(x){}
  go.disabled=true;go.textContent='Sending…';
  setTimeout(function(){go.disabled=false;go.textContent='Request Enrollment →'},6000);
});
/* Came back from a native (challenge) submit: show the success state. */
try{if(sessionStorage.getItem('yfla_em')==='1'&&/contact_posted=true/.test(location.search)){sessionStorage.removeItem('yfla_em');em.classList.add('done');em.classList.add('on')}}catch(x){}
})();
